import { useMediaQuery } from "react-responsive";
import type {
	BreakpointDefinitions,
	BreakpointName,
} from "./breakpoints.types";

export interface UseBreakpointProps {
	up?: boolean;
	down?: boolean;
	minWidth?: number;
	maxWidth?: number;
}

export const useBreakpoint = ({
	up = false,
	down = false,
	minWidth,
	maxWidth,
}: UseBreakpointProps) =>
	useMediaQuery({
		minWidth: down ? undefined : minWidth,
		maxWidth: up ? undefined : maxWidth,
	});

export const createBreakpointHooks = (breakpoints: BreakpointDefinitions) => ({
	useMobileBreakpoint: (props?: UseBreakpointProps) =>
		useBreakpoint({ maxWidth: breakpoints.mobile, ...props }),
	useTabletBreakpoint: (props?: UseBreakpointProps) =>
		useBreakpoint({
			minWidth: breakpoints.mobile + 1,
			maxWidth: breakpoints.tablet,
			...props,
		}),
	useDesktopBreakpoint: (props?: UseBreakpointProps) =>
		useBreakpoint({
			minWidth: breakpoints.tablet + 1,
			maxWidth: breakpoints.desktop,
			...props,
		}),
	useXLDesktopBreakpoint: (props?: UseBreakpointProps) =>
		useBreakpoint({ minWidth: breakpoints.desktop + 1, ...props }),
	useBreakpointName: (props?: UseBreakpointProps): BreakpointName => {
		const mobile = useMediaQuery({ maxWidth: breakpoints.mobile, ...props });
		const tablet = useMediaQuery({
			minWidth: breakpoints.mobile + 1,
			maxWidth: breakpoints.tablet,
			...props,
		});

		if (mobile) return "mobile";

		if (tablet) return "tablet";

		return "desktop";
	},
});

export default useBreakpoint;
